var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Icons",
    viewBox: "0 0 74 74",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6,52.57a1,1,0,0,1-1-1V48.6a1,1,0,0,1,2,0v2.97A1,1,0,0,1,6,52.57Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66,72H8a3,3,0,0,1-3-3V58.57a1,1,0,1,1,2,0V69a1,1,0,0,0,1,1H66a1,1,0,0,0,1-1V21.24a1,1,0,0,0-.3-.714L50.463,4.3A1,1,0,0,0,49.75,4H8A1,1,0,0,0,7,5V31.69a1,1,0,0,1-2,0V5A3,3,0,0,1,8,2H49.75a2.985,2.985,0,0,1,2.127.883l16.24,16.229A2.992,2.992,0,0,1,69,21.24V69A3,3,0,0,1,66,72Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6,42.6a1,1,0,0,1-1-1V38.69a1,1,0,0,1,2,0V41.6A1,1,0,0,1,6,42.6Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.917,14h-26a2.086,2.086,0,0,1-2.084-2.083V3a1,1,0,0,1,1-1H44a1,1,0,0,1,1,1v8.917A2.086,2.086,0,0,1,42.917,14ZM16.833,4v7.917a.084.084,0,0,0,.084.083h26A.083.083,0,0,0,43,11.917V4Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.812,10.219a1,1,0,0,1-1-1V6.781a1,1,0,1,1,2,0V9.219A1,1,0,0,1,36.812,10.219Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59,72H15a1,1,0,0,1-1-1V40a3,3,0,0,1,3-3H57a3,3,0,0,1,3,3V71A1,1,0,0,1,59,72ZM16,70H58V40a1,1,0,0,0-1-1H17a1,1,0,0,0-1,1Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.281,46.75H22.719a1,1,0,1,1,0-2H51.281a1,1,0,1,1,0,2Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.281,55.5H22.719a1,1,0,1,1,0-2H51.281a1,1,0,1,1,0,2Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.281,64.25H22.719a1,1,0,1,1,0-2H51.281a1,1,0,1,1,0,2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.84956fdd179bc24b9fd33c52860012ab.svg";
export { ForwardRef as ReactComponent };